import * as Yup from "yup";


// Validation Schema using Yup
const careervalidationSchema = Yup.object({
    fullname: Yup.string()
      .required("Full Name is required")
      .min(2, "Full Name must be at least 2 characters"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phonenumber: Yup.string()
      .required("Phone Number is required")
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
    position: Yup.string().required("Position is required"),
    linkedinprofile: Yup.string()
      .url("Invalid LinkedIn URL")
      .required("LinkedIn profile is required"),
    comments: Yup.string().required("Comments are required"),
    cv: Yup.mixed()
      .required("CV is required")
      // .test(
      //   "fileSize",
      //   "File is too large (max size: 4MB)",
      //   (value) => value && value.size <= 4 * 1024 * 1024 // 2MB
      // )
      // .test(
      //   "fileFormat",
      //   "Unsupported file format. Upload PDF only",
      //   (value) => value && ["application/pdf"].includes(value.type)
      // )
      ,
    checkbox: Yup.boolean()
      .required("You must agree to the terms")
      .oneOf([true], "You must agree to the terms"),
  });

  export default careervalidationSchema;